import "../style/About.css";
const About = () => {
  return (
    <div className="about bg-customCreamyButterLight">
      <h2>About Us</h2>
      <br/>
      <p>
        We are <span>Keepsake</span>, a peer-to-peer platform that connects people who need
        storage space with people who have extra space. Whether you want to
        store your car, RV, furniture, or business inventory, we can help you
        find a safe, convenient, and affordable space near you.
      </p>
      <p>
        We believe that storage should be easy, accessible, and
        community-driven. That’s why we created <span>Keepsake</span>, a platform that lets
        you rent out your unused space and earn extra income, or find a storage
        space that suits your needs and budget.
      </p>
      <h3>With <span>Keepsake</span>, you can:</h3>
      <br />
      <ul>
        <li>Save up to 50% compared to traditional self-storage units</li>
        <li>
          Choose from a variety of storage options, such as garages, basements,
          attics, sheds, or driveways
        </li>
        {/* <li>Enjoy peace of mind with our $1 million host guarantee and $25,000 renter guarantee</li> */}
        <li>Support local homeowners and businesses in your area</li>
        <li>Access your belongings anytime with flexible arrangements</li>
      </ul>
      <br />
      <p>
        Join <span>Keepsake</span> today and discover the benefits of peer-to-peer storage.
        Whether you have space or need space, we have you covered.
      </p>
      <br/>
      <h2>How It Works</h2>
      <br/>
      <ul>
        <li>
          If you have space, sign up as a host and list your space for free. You
          can set your own price, availability, and rules for your space. You
          can also upload photos and a description of your space to attract
          renters.
        </li>
        <li>
          If you need space, sign up as a renter and browse through thousands of
          spaces near you. You can filter by location, size, price, and
          amenities. You can also read reviews and ratings from other renters to
          find the best space for you.
        </li>
        <li>
          Once you find a space that you like, you can book it online with a few
          clicks. You can also message the host directly to ask any questions or
          arrange a viewing.
        </li>
        <li>
          After you book a space, you can move in your belongings and access
          them anytime. You can also extend or cancel your booking anytime with
          our flexible policies.
        </li>
        <li>
          We handle all the payments and transactions securely and
          automatically. You only pay for the space that you use, and you can
          earn money from the space that you don't use.
        </li>
      </ul>
      <br/>
      <h2>Why Choose Us</h2>
      <br/>
      <ul>
        <li>
          We are affordable. We offer competitive prices that are lower than
          traditional self-storage units. You can save money and get more value
          for your space.
        </li>
        <li>
          We are convenient. We have a large network of spaces across the
          country, so you can find a space that is close to your home or work.
          You can also access your space anytime, without any hassle or extra
          fees.
        </li>
        <li>
          We are safe. We verify all our hosts and renters, and we provide
          insurance coverage for both parties. You can also review and rate your
          experience and report any issues or disputes to our customer support
          team.
        </li>
        <li>
          We are eco-friendly. We reduce the need for new construction and land
          use, and we promote the reuse and sharing of existing spaces. You can
          also reduce your carbon footprint by storing your belongings locally.
        </li>
        <li>
          We are social. We connect you with people who have similar interests
          and needs. You can meet new friends, exchange tips, and join our
          online community.
        </li>
      </ul>
    <br/>
      <h2>Our Mission</h2>
      <br/>
      <p>
        Our mission is to make storage simple, accessible, and community-driven.
        We want to empower people to share their space and resources and to
        create a more sustainable and connected world. We believe that space is
        not just a commodity but a way of life.
      </p>
    </div>
  );
};

export default About;
